import axios from "axios";
import config from "@/router/globalConfig";

export default {
    ShowMyBooking(_data_) {
        return axios.get(config.WEB_API_PATH + 'MyBooking/ShowMyBooking', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetPrintTicket(_data_) {
        return axios.get(config.WEB_API_PATH + 'MyBooking/GetPrintTicket', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetFailedPayment(_data_) {
        return axios.get(config.WEB_API_PATH + 'RefundPayment/GetFailedPayment', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
};


// WEBPACK FOOTER //
// ./src/components/servicesJS/MyBooking.js